/**
 * Where the access token lives.
 *
 * In memory, deliberately. localStorage survives a tab close but is readable by
 * any script that manages to run on the page, which turns one XSS into a
 * permanent account takeover. The refresh token is expected to be an HttpOnly
 * cookie the JS never sees; on load the app calls the refresh endpoint to get a
 * fresh access token, so a reload is a network round-trip rather than a logout.
 */
let accessToken: string | null = null;

export const tokenStore = {
  get: (): string | null => accessToken,

  set: (token: string | null): void => {
    accessToken = token;
  },

  clear: (): void => {
    accessToken = null;
  },
};
